import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import styles from "./tooltip-bubble.module.scss";

const TooltipBubble = ({ content, children, disabled = false }) => {
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const wrapperRef = useRef(null);

  const handleMouseEnter = () => {
    if (!disabled) setVisible(true);
  };

  const handleMouseLeave = () => {
    if (!disabled) setVisible(false);
  };

  useEffect(() => {
    if (visible && wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      // Position tooltip above the element if near bottom, else below
      const tooltipHeight = 48; // Approximate height
      const spaceBelow = window.innerHeight - rect.bottom;
      const showAbove = spaceBelow < tooltipHeight;
      setCoords({
        top: showAbove ? rect.top - tooltipHeight : rect.bottom,
        left: rect.left + rect.width / 2,
        showAbove,
      });
    }
  }, [visible]);

  const tooltipNode =
    visible && !disabled
      ? ReactDOM.createPortal(
          <div
            className={styles.tooltipContainer}
            style={{
              position: "fixed",
              top: coords.top,
              left: coords.left,
              transform: "translateX(-50%)" + (coords.showAbove ? " translateY(-100%)" : ""),
              zIndex: 1000,
              pointerEvents: "none",
            }}
          >
            <span
              className={styles.tooltipArrow}
              style={{
                transform: coords.showAbove ? "rotate(180deg)" : "none",
                marginBottom: coords.showAbove ? undefined : -1,
                marginTop: coords.showAbove ? -7 : undefined,
              }}
            />
            <div className={styles.tooltipBubble}>{content}</div>
          </div>,
          document.body
        )
      : null;

  return (
    <div
      className={styles.tooltipWrapper}
      ref={wrapperRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {tooltipNode}
    </div>
  );
};

export default TooltipBubble;
